export const coreTeam ={
    "Head": [],
    "Secretary": [],
    "Convenor": []
  }
  
  
  export const developers ={
    fullStack:[{
      "Name": "Ayush Kansal",
      "Committee": "Websiite Management",
      Instagram:"NA",
      Linkedin:"https://www.linkedin.com/in/ayush-kansal-a6b788279/",
      "Photo": "/team/Ayush_Kansal.png",
      "Email": "ayushkansal42@gmail.com",
      "Contact": "XXXXXXXXXX",
      "Type": "Head"
    },
    {
      "Name": "Prranav Babbar",
      "Committee": "Website Management",
      Instagram:"NA",
      Linkedin:"NA",
      "Photo": "/team/PrranavBabbar.webp",
      "Email": "NA",
      "Contact": "XXXXXXXXXX",
      "Type": "Head"
    },],
    ui:[]
  }
